import { accountsEnvironment } from '../accounts-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { copilotLogListSchema } from '../schemas/copilot-log-list.schema';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { AuthHeaders } from '../../../models/auth-headers';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

/**
 * Get log information for a specified Device
 * @param accountId ID of Account
 * @param deviceId ID of Device
 * @param startDate Start Date
 * @param endDate End Date
 * @returns An array of CoPilot Log Lists for each User
 */
export function postDeviceLogs(
  this: unknown,
  accountId: number,
  deviceId: string,
  startDate: Date,
  endDate: Date
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(`${accountsEnvironment.resolve(this).deviceLogsUrl}`, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
            ? new AuthHeaders()
            : jwtAuthHeaders),
        },
        body: JSON.stringify({
          accountId,
          deviceId,
          startDate,
          endDate,
        }),
      })
    )
  ).pipe(selectData(z.array(copilotLogListSchema)));
}
